import type { ReactNode } from 'react';

export interface TimelineItem {
  id: string;
  at: string;
  title: string;
  detail?: ReactNode;
}
export interface TimelineProps {
  items: readonly TimelineItem[];
  label: string;
  formatTime(timestamp: string): string;
}
export function Timeline({ items, label, formatTime }: TimelineProps) {
  return (
    <ol className="pc-timeline" aria-label={label}>
      {items.map((item) => (
        <li className="pc-tl-item" key={item.id}>
          <time dateTime={item.at}>{formatTime(item.at)}</time>
          <div>
            <strong>{item.title}</strong>
            {item.detail && <div>{item.detail}</div>}
          </div>
        </li>
      ))}
    </ol>
  );
}
